import { RootState } from "@/shared/types";
import { IUsersData, IGetManyUsersParams } from "./types/interfaces";

export const selectUsers = (state: RootState): IUsersData => state.users.data;

export const selectParams = (state: RootState): IGetManyUsersParams =>
  state.users.params;
